import { Actions } from 'vuex-smart-module';
// import { ResponseStatuses } from '@/enums';
// import { AxiosResponse } from 'axios';
import { Filters, FiltersPagination } from '@/types';
import { StaffsService } from '@/modules/staffs/services';
// import { Staffs } from '@/modules/staffs/types';
import AnalitycsListState from './state';
import AnalitycsListMutations from './mutations';
import AnalitycsListGetters from './getters';

const staffService = new StaffsService();

export default class AnalitycsListActions extends Actions<
AnalitycsListState,
AnalitycsListGetters,
AnalitycsListMutations,
  // eslint-disable-next-line no-use-before-define
AnalitycsListActions
> {
  async get_statistics() {
    try {
      const { sortBy = [], sortDesc = [] } = this.state.table_options;
      const { current_page, limit } = this.state.pagination_props;
      const payload: FiltersPagination<Filters> = {
        filters: this.state.filters,
        pagination: {
          limit,
          page: current_page,
          sort: '',
          sort_type: 'asc',
        },
      };

      if (sortBy?.length) {
        [payload.pagination.sort] = sortBy;
      }

      if (sortDesc?.length) {
        payload.pagination.sort_type = sortDesc[0] ? 'desc' : 'asc';
      }

      this.mutations.TOGGLE_LOADING_STATISTICS(true);
      const { data } = await staffService.get_statistics(payload);

      this.mutations.SET_STATISTICS(data.items);
    } catch (error) {
      console.error(error);
    } finally {
      this.mutations.TOGGLE_LOADING_STATISTICS(false);
    }
  }
}
